const orgLurePendingColumns = [
  {
    prop: 'pestType',
    label: 'Pest type',
    editable: false,
    sortable: false,
    width: 150
  },
  {
    prop: 'productCode',
    label: 'Product code',
    editable: false,
    sortable: false,
    width: 150
  },
  {
    prop: 'productName',
    label: 'Product name',
    editable: false,
    sortable: false,
    width: 150
  },
  {
    prop: 'quantity',
    label: 'No.',
    editable: true,
    editType: 'number',
    sortable: false,
    width: 150
  },
  {
    prop: 'lureDueDate',
    label: 'Due Date',
    editable: true,
    editType: 'datepicker',
    sortable: false,
    width: 200
  },
  {
    prop: 'isTrial',
    label: 'Trial',
    sortable: false,
    width: 100
  },
  {
    prop: 'comments',
    label: 'Comments',
    editable: true,
    sortable: false,
    width: 200
  },
];

const orgLureSentColumns = [
  {
    prop: 'pestType',
    label: 'Pest type',
    sortable: false,
    width: 150
  },
  {
    prop: 'productCode',
    label: 'Product code',
    sortable: false,
    width: 150
  },
  {
    prop: 'productName',
    label: 'Product name',
    sortable: false,
    width: 150
  },
  {
    prop: 'quantity',
    label: 'Quantity',
    sortable: false,
    width: 120
  },
  {
    prop: 'lureDueDate',
    label: 'Due Date',
    sortable: false,
    width: 150
  },
  {
    prop: 'lureShipDate',
    label: 'Ship Date',
    sortable: false,
    width: 150
  },
  {
    prop: 'isTrial',
    label: 'Trial',
    sortable: false,
    width: 100
  },
  {
    prop: 'comments',
    label: 'Comments',
    sortable: false,
    width: 200
  },
];

const orgLureOptions = {
  'default-sort': {
    prop: 'lureDueDate',
    order: 'desc'
  },
  limit: 10,
  searchParams: {
    default: 'code',
    params: [
      {
        label: 'Code',
        value: 'code',
      }
    ]
  }
};

const orgBatterySentColumns = [
  {
    prop: 'batteryQuantity',
    label: 'Quantity',
    sortable: false,
    width: 120
  },
  {
    prop: 'batteryShipDate',
    label: 'Ship Date',
    sortable: false,
    width: 150
  },
  {
    prop: 'batteryComments',
    label: 'Battery Comments',
    sortable: false,
    width: 200
  },
];

export { orgLurePendingColumns, orgLureSentColumns, orgLureOptions, orgBatterySentColumns }